import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

export const useAudioMessageViewed = ({ messageId }: { messageId: number }) =>
	useSendEvent(events.audio.messageViewed, {
		'message-id': messageId,
	});

export const usePlayAudioButtonClicked = ({
	messageId,
}: {
	messageId: number;
}) =>
	useSendEvent(events.audio.playButtonClicked, {
		'message-id': messageId,
	});

export const useAudioMessagePlaybackPaused = ({
	messageId,
	text,
}: {
	messageId: number;
	text: string;
}) =>
	useSendEvent(events.audio.playButtonClicked, {
		'message-id': messageId,
		text,
	});

export const useAudioMessagePlaybackCompleted = ({
	messageId,
	duration,
	text,
}: {
	messageId: number;
	text: string;
	duration?: number;
}) =>
	useSendEvent(events.audio.playbackCompleted, {
		'message-id': messageId,
		duration,
		text,
	});

export const useAudioMessagePlaybackStarted = ({
	messageId,
	text,
}: {
	messageId: number;
	text: string;
}) =>
	useSendEvent(events.audio.playbackStarted, {
		'message-id': messageId,
		text,
	});
